/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FC } from 'react';

import {
  EuiBreadcrumb,
  EuiHorizontalRule,
  EuiPageTemplate,
  EuiPageTemplateProps,
  EuiSpacer,
  EuiText,
} from '@elastic/eui';
import { useRouter } from 'next/router';
import { HeaderPrimary } from '@components/header/header-primary';
import { HeaderSecondary } from '@components/header/header-secondary';
import Spinner from '@components/spinner/spinner';

export type Props = {
  breadcrumb?: EuiBreadcrumb[];
  alignment?: 'top' | 'center' | 'horizontalCenter';
  panelled?: boolean;
  restrictWidth?: string | number | boolean;
  pageTitle?: string;
  showSpinner?: boolean;
  noAuth?: boolean;
};

const MainLayout: FC<EuiPageTemplateProps & Props> = ({
  children,
  breadcrumb,
  pageTitle,
  alignment,
  panelled,
  restrictWidth,
  showSpinner = false,
  noAuth,
  ...rest
}) => {
  const router = useRouter();
  const showSubHeader =
    !['/', '/choose-congress', '/403', '/error'].includes(router.route) &&
    !router.route.startsWith('/auth');

  const renderPageTitle = (
    <>
      <EuiText size="xs">
        <h2>{pageTitle}</h2>
      </EuiText>
      <EuiHorizontalRule margin="m" color="lightgray" />
    </>
  );

  return (
    <div css={{ position: 'relative' }}>
      <Spinner show={showSpinner} />

      <EuiPageTemplate panelled={panelled} restrictWidth={true} {...rest}>
        <HeaderPrimary noAuth={noAuth} />

        {showSubHeader ? <HeaderSecondary breadcrumb={breadcrumb} /> : null}

        <EuiSpacer size="s" />

        <EuiPageTemplate.Section
          grow={true}
          paddingSize="m"
          restrictWidth={restrictWidth === undefined ? 800 : restrictWidth}
          alignment={alignment || 'top'}
          bottomBorder={false}>
          {pageTitle ? renderPageTitle : null}
          {children}
        </EuiPageTemplate.Section>
      </EuiPageTemplate>
    </div>
  );
};

export default MainLayout;
